import { clsx } from 'clsx'
import { type FC } from 'react'

import { ErrorBoundary } from '../../../../error-boundary'
import { useGetIsChristmasCommunicationEnabled } from '../../../../experiments/christmas-communication/useGetIsChristmasCommunicationEnabled'
import { useGetExperiment } from '../../../../experiments/hooks'
import { EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS } from '../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../experiments/model/EXPERIMENT_VARIATION'
import { useIsNowEnabled, useNowGeneralContext } from '../../../../now'
import { productAccessorIsCoolingProduct } from '../../../model/productAccessor/productAccessorIsCoolingProduct'
import { productAccessorIsPrescriptionProduct } from '../../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { productAccessorIsSaeOffer } from '../../../model/productAccessor/productAccessorIsSaeOffer'
import { useProductPageContext } from '../../productPageContext'
import { useProductPrices } from '../hooks/useProductPrices'
import { ProductBuyBoxChristmasCommunication } from '../ProductBuyBoxChristmasCommunication'
import { ProductBuyBoxDeliveryOptions } from '../ProductBuyBoxDeliveryOptions'
import { ProductBuyBoxNowInfo } from '../ProductBuyBoxNowInfo/ProductByBoxNowInfo'
import { ProductBuyBoxStockStatusAndDeliveryInfo } from '../ProductBuyBoxStockStatusAndDeliveryInfo'
import { ProductNowDeliveryBox } from '../ProductNowDeliveryBox'

export const ProductBuyBoxNowDetails: FC = () => {
  const {
    currentOffer,
    currentPrescriptionType,
    currentVariant,
    nowDetails,
    offerId,
    product,
  } = useProductPageContext()
  const { nowGeneralData } = useNowGeneralContext()
  const isNowEnabled = useIsNowEnabled()
  const isPrescriptionProduct =
    productAccessorIsPrescriptionProduct(currentVariant)
  const isMarketplace = currentOffer
    ? !productAccessorIsSaeOffer(currentOffer)
    : false
  const isCoolingProduct = productAccessorIsCoolingProduct(currentVariant)
  const christmasCommunicationEnabled =
    useGetIsChristmasCommunicationEnabled(isCoolingProduct)

  const { isOfferMirakl } = useProductPrices({
    currentPrescriptionType,
    offerId,
    product,
  })

  const pdpDeliveryOptions = useGetExperiment(
    EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS,
  )

  return (
    <div
      className={clsx(
        pdpDeliveryOptions.isEnabled &&
          (pdpDeliveryOptions.variant === EXPERIMENT_VARIATION.V2 ||
            pdpDeliveryOptions.variant === EXPERIMENT_VARIATION.V4) &&
          'mt-4',
      )}
    >
      <ProductBuyBoxStockStatusAndDeliveryInfo />
      {pdpDeliveryOptions.isEnabled &&
      pdpDeliveryOptions.variant !== EXPERIMENT_VARIATION.DEFAULT &&
      !isMarketplace ? (
        <ProductBuyBoxDeliveryOptions />
      ) : null}
      {!isPrescriptionProduct && christmasCommunicationEnabled ? (
        <ProductBuyBoxChristmasCommunication
          isCoolingProduct={isCoolingProduct}
        />
      ) : null}
      {isNowEnabled &&
      nowDetails.nowCustomerJourneyEnabled &&
      !isOfferMirakl &&
      !nowDetails.savedZipCode &&
      !nowGeneralData.zipSupportInfo?.zip ? (
        <ProductNowDeliveryBox />
      ) : null}
      {isNowEnabled &&
      !isPrescriptionProduct &&
      !pdpDeliveryOptions.isEnabled ? (
        <ErrorBoundary>
          <ProductBuyBoxNowInfo />
        </ErrorBoundary>
      ) : null}
    </div>
  )
}
